import React, { Fragment } from 'react'

// icons
import { faBarcode } from '@fortawesome/free-solid-svg-icons'

// styles
import './Articulos.css'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemArticuloEliminado from './ItemArticuloEliminado'

// services

// route
import { withRouter } from 'react-router-dom'
import Header from '../Header/Header'

// alert swal
import routes from '../../Routes'
import usePagination from './hooks/usePagination'
import HeaderPagination from '../Custom/HeaderPagination'
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'

const visibleButtons = {
    create: false,
    import: false,
    export: false,
    deleted: false,
    search: true,
}

function ArticulosEliminados({ history }) {
    const {
        articulos,
        setIsLoad,
        page,
        totalRegister,
        totalPage,
        handleBuscador,
        nextPage,
        previousPage,
        searchCriteria,
        setSearchCriteria,
        getCriteriaLabel,
    } = usePagination(history, false)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faBarcode}
                        title={'Articulos Eliminados'}
                    />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.ARTICULO}
                    visibleButtons={visibleButtons}
                    handleBuscador={handleBuscador}
                    searchCriteria={searchCriteria}
                    setSearchCriteria={setSearchCriteria}
                    getCriteriaLabel={getCriteriaLabel}
                />

                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Codigo</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Pesable</th>
                            <th scope="col">Balanza</th>
                            <th scope="col">Compuesto</th>
                            <th scope="col">Costo</th>
                            <th scope="col">Precio Final</th>
                            <th scope="col">Ganancia</th>
                            <th scope="col">Familia</th>
                            <th scope="col">Marca</th>
                            <th scope="col">Unidad Medida</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {articulos.map((articulo) => (
                            <ItemArticuloEliminado
                                key={parseInt(articulo.id, 10)}
                                setIsLoad={setIsLoad}
                                articulo={articulo}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(ArticulosEliminados)
